(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/set-self-exclusion.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/set-self-exclusion.js');
'use strict';

const {
  Vertical,
  NativeApp
} = svs.selfExclusion.components;
const {
  ReactButton: Button
} = svs.ui;
const {
  Form
} = svs.ui.reactForm;
const {
  useAtom
} = jotai;
const {
  gameAtom,
  periodAtom,
  activeExclusionsAtom,
  isNaExcludedAtom,
  submitAtom
} = svs.selfExclusion.atoms.selfExclusionAtoms;
const {
  DataService
} = svs.accountservices.player_exclusions;
const {
  DOCS,
  isNativeApp
} = svs.selfExclusion.Constants;
const {
  useEffect
} = React;
const SetSelfExclusion = () => {
  const [game, setGame] = useAtom(gameAtom);
  const [period, setPeriod] = useAtom(periodAtom);
  const [, setActiveExclusions] = useAtom(activeExclusionsAtom);
  const [, setNaExcluded] = useAtom(isNaExcludedAtom);
  const [isSubmitted, setiIsSubmitted] = useAtom(submitAtom);
  useEffect(() => {
    if (isSubmitted) {
      setiIsSubmitted(false);
    }
  }, [isSubmitted, setiIsSubmitted]);
  const handleSubmit = e => {
    e.preventDefault();
    DataService.setSelfExclusion(game, period, setActiveExclusions, setNaExcluded);
    setGame();
    setPeriod();
    setiIsSubmitted(true);
  };
  return React.createElement(React.Fragment, null, React.createElement("section", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2",
    id: "set-self-exclusions"
  }, React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement("h2", {
    className: "align-center f-700 f-bold",
    tabIndex: 0
  }, "Spelpaus i 3 m\xE5nader - 3 \xE5r"), React.createElement(Vertical, {
    key: isSubmitted
  }), React.createElement("p", {
    tabIndex: 0
  }, "Genom att aktivera en l\xE4ngre spelpaus godk\xE4nner du", ' ', isNativeApp ? React.createElement(NativeApp, null) : React.createElement("a", {
    href: DOCS.PERSONAL_INFORMATION,
    rel: "noreferrer",
    target: "_blank"
  }, "villkoren f\xF6r spelpaus"), ' ', "och bekr\xE4ftar att du tagit del av", ' ', React.createElement("a", {
    href: DOCS.PERSONAL_POLICY,
    rel: "noreferrer",
    target: "_blank"
  }, "information om behandling av personuppgifter."), ' '), React.createElement(Button, {
    block: true,
    disabled: !period,
    inverted: true,
    size: 300,
    type: "submit"
  }, "Pausa"))), React.createElement("hr", {
    className: "exclusion-border-bottom"
  }));
};
svs.selfExclusion.components.SetSelfExclusion = SetSelfExclusion;

 })(window);